import { render, staticRenderFns } from "./edit-user-info.vue?vue&type=template&id=5b9e9cee&scoped=true&"
import script from "./edit-user-info.vue?vue&type=script&lang=js&"
export * from "./edit-user-info.vue?vue&type=script&lang=js&"
import style0 from "./edit-user-info.vue?vue&type=style&index=0&id=5b9e9cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e9cee",
  null
  
)

export default component.exports